// project import
import { buildAdminMenu } from './admin';
import { buildAttendanceDashboardMenu } from './attendance';
import dashboard, { buildDashboardMenu } from './dashboard';

// ==============================|| MENU ITEMS ||============================== //
// Demo groups (component-overview pages, utilities, support/sample-page)
// removed - not relevant to do-ra.cz. Each real module adds its own entry
// here as it's built.
//
// menu-items/attendance.jsx exportuje jedinou věc: buildAttendanceDashboardMenu()
// - vlastní top-level skupina "Docházkový systém" (launcher na "Řídicí
// panel" podle role), volaná přímo tady. Do 2026-09-02 existoval ještě
// buildAttendanceManagerCollapse() (operativní CRUD collapse vnořený
// buildAdminMenu()em dovnitř "Manažeři") - na výslovné přání uživatele
// zrušen, všechny jeho odkazy přesunuty sem.
//
// buildMenuItems(user) (named export) builds what the SIDEBAR should
// actually render, filtered by the caller's real /auth/me payload
// (admin_access flags + the generic `permissions` array, 2026-08-22 -
// "core_modules" katalog) - a user without any admin role never gets an
// "Administrace" group at all. The default export below stays a static,
// unfiltered menu used only by Breadcrumbs.jsx to look up a page's title/
// icon for whatever URL the user is already ON - the route guards
// (utils/route-guard/RequireModuleAccess, RequireAdminAccess) are what
// actually stop someone reaching a URL they're not allowed on, so this
// static lookup table isn't a second copy of the access rule and isn't a
// security concern. It uses a synthetic "sees everything" user - a single
// direct system/admin grant, which hasModuleAccess()'s superadmin bypass
// already treats as unlocking every moduleKey/minRole check.
const FULL_ACCESS_USER = {
  admin_access: { is_system_admin: true, is_group_admin: true },
  permissions: [{ module_key: 'system', widget_key: null, role: 'admin', source: 'synthetic' }]
};

const menuItems = {
  items: [dashboard, buildAttendanceDashboardMenu(FULL_ACCESS_USER), buildAdminMenu(FULL_ACCESS_USER)].filter(Boolean)
};

export function buildMenuItems(user) {
  const attendanceDashboardMenu = buildAttendanceDashboardMenu(user);
  const adminMenu = buildAdminMenu(user);

  return {
    items: [buildDashboardMenu(user), ...(attendanceDashboardMenu ? [attendanceDashboardMenu] : []), ...(adminMenu ? [adminMenu] : [])]
  };
}

export default menuItems;
